export default "__VITE_ASSET__bb8f2fa8__"